import {
  add_file,
  close_modal,
  cropper_modal_cancel,
  error_modal_cancel,
  reset_state,
  set_crop,
  set_cropped_area_pxls,
  set_err,
  set_file_data,
  set_zoom,
} from './actionTypes';
import { initialState, modalModes, stateKeys } from './constants';

const {
  modalVisible: modalVisibleKey,
  modalMode: modalModeKey,
  modalModeHistory: modalModeHistoryKey,
  file: fileKey,
  fileSrc: fileSrcKey,
  zoom: zoomKey,
  crop: cropKey,
  croppedAreaPxls: croppedAreaPxlsKey,
  initialCroppedArea: initCropAreaKey,
  errMsgs: errMsgsKey,
} = stateKeys;

const updateModalHistory = (state) => {
  const currentMode = state[modalModeKey];
  const history = state[modalModeHistoryKey];

  if (currentMode && currentMode !== modalModes.error) {
    return [...history, currentMode];
  }

  return history;
};

const updateModalStateAfterCancel = (state) => {
  const history = state[modalModeHistoryKey];

  return {
    [modalVisibleKey]: Boolean(history.length),
    [modalModeKey]: history[history.length - 1],
    [modalModeHistoryKey]: history.slice(0, -1),
  };
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case add_file: {
      return {
        ...state,
        [modalVisibleKey]: true,
        [modalModeKey]: modalModes.initial,
      };
    }

    case close_modal: {
      return {
        ...state,
        [modalVisibleKey]: false,
      };
    }

    case cropper_modal_cancel: {
      const modalState = updateModalStateAfterCancel(state);

      if (modalState[modalVisibleKey]) {
        return {
          ...state,
          ...modalState,
          [fileKey]: null,
          [fileSrcKey]: '',
          [zoomKey]: 1,
          [initCropAreaKey]: null,
          [croppedAreaPxlsKey]: null,
          [cropKey]: { x: 0, y: 0 },
        };
      } else {
        return {
          ...state,
          [modalVisibleKey]: modalState[modalVisibleKey],
        };
      }
    }

    case set_err: {
      return {
        ...state,
        [errMsgsKey]: payload,
        [modalModeKey]: modalModes.error,
        [modalVisibleKey]: true,
        [modalModeHistoryKey]: updateModalHistory(state),
      };
    }

    case error_modal_cancel: {
      const modalState = updateModalStateAfterCancel(state);

      if (modalState[modalVisibleKey]) {
        return {
          ...state,
          ...modalState,
          [errMsgsKey]: null,
        };
      } else {
        return {
          ...state,
          [modalVisibleKey]: modalState[modalVisibleKey],
        };
      }
    }

    case set_file_data: {
      return {
        ...state,
        ...payload,
        [modalModeHistoryKey]: updateModalHistory(state),
        [modalModeKey]: modalModes.cropper,
        [modalVisibleKey]: true,
      };
    }

    case set_zoom: {
      return {
        ...state,
        [zoomKey]: payload,
      };
    }

    case set_crop: {
      return {
        ...state,
        [cropKey]: payload,
      };
    }

    case set_cropped_area_pxls: {
      return {
        ...state,
        [croppedAreaPxlsKey]: payload,
      };
    }

    case reset_state: {
      return initialState;
    }
  }

  throw Error('Неизвестное действие: ' + type);
};
